import {
  ModalsProvider,
  type ModalsProviderProps,
} from '@mantine/modals';
import {
  Notifications,
} from '@mantine/notifications';
import {
  QueryClientProvider,
} from '@tanstack/react-query';
import {
  ReactQueryDevtools,
} from '@tanstack/react-query-devtools';
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from '@tanstack/react-router';
// Debug tools, automatically excluded from production builds
import {
  TanStackRouterDevtools,
} from '@tanstack/react-router-devtools';

import {
  type RootRouterContext,
} from '#src/types/routerContext';

const modalProviderDefaults: ModalsProviderProps['modalProps'] = {
  transitionProps: {
    transition: 'slide-up',
    duration: 500,
    timingFunction: 'ease-in-out',
    exitDuration: 1000,
    keepMounted: true,
  },
  size: 'xl',
  zIndex: 'calc(1 + var(--mantine-z-index-overlay))',
  overlayProps: {
    backgroundOpacity: 0.3,
    zIndex: 'var(--mantine-z-index-overlay)',
  },
  radius: 'lg',
  padding: 'lg',
  keepMounted: true,
  lockScroll: true,
  returnFocus: true,
  trapFocus: true,
};
export const Route = createRootRouteWithContext<RootRouterContext>()({
  loader: ({
    context,
  }) => {
    return context;
  },
  component() {
    const {
      queryClient,
    } = Route.useLoaderData();
    return (
      <>
        <HeadContent />
        <QueryClientProvider
          client={ queryClient }
        >
          <Notifications
            zIndex="var(--mantine-z-index-max)"
            position="top-right"
            limit={ 5 }
          />
          <ModalsProvider
            modalProps={ modalProviderDefaults }
          >
            <TanStackRouterDevtools />
            <ReactQueryDevtools
              initialIsOpen={ false }
            />
            <Outlet />
          </ModalsProvider>
        </QueryClientProvider>
      </>
    );
  },
});
